import IValidationRule from "./ValidationRule";

export type ValidationRuleFunctionProp = Function | ((value: any) => string | undefined);

export default class ValidationRuleFunction implements IValidationRule {
  private _message: string | undefined;
  private _func: ValidationRuleFunctionProp;

  public constructor(_func: ValidationRuleFunctionProp) {
    this._func = _func;
  }

  public get message(): string | undefined {
    return this._message;
  }

  public check(value: any): boolean {
    this._message = this._func(value);

    return this._message == null;
  }
}
